<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="12">
            <h4 id="traffic" class="card-title mb-0">Agrupación</h4>
            <div class="small text-muted">Agrupación de servidores y sistemas</div>
          </b-col>
        </b-row>
      </b-card>

      <b-tabs v-model="activeTab" @input="onTabChange">
        <b-tab title="Servidores">
          <b-row class="mt-2">
            <b-col sm="12" class="mb-2">
              <b-button @click="add('server')" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Categoría para Servidores">
                <i class="fa fa-plus"></i> Agregar
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table class="mb-0"
                        ref="tableServer"
                        responsive="sm"
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.itemsServer"
                        :fields="table.fieldsServer"
                        :current-page="table.currentPageServer"
                        :per-page="table.perPage"
                        :busy="table.isBusyServer"
                        v-if="table.itemsServer.length || table.isBusyServer">

                <template v-slot:cell(id)="data">
                  <b>#{{data.item.id}}</b>
                </template>

                <template v-slot:cell(name)="data">
                  {{data.item.name}}
                </template>

                <template v-slot:cell(related_count)="data">
                  {{getRelatedCount(data.item)}}
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
                    <b-dropdown-item @click="edit(data.item)">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="table.tablePaginateServer">
          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.tablePaginateServer.total"
                            :per-page="table.tablePaginateServer.per_page"
                            v-model="table.currentPageServer"
                            @input="filterServer()" />
            </nav>
          </b-col>
        </b-row>
        </b-tab>

        <b-tab title="Sistemas">
          <b-row class="mt-2">
            <b-col sm="12" class="mb-2">
              <b-button @click="add('system')" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Categoría para Sistemas">
                <i class="fa fa-plus"></i> Agregar
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table class="mb-0"
                      ref="tableSystem"
                      responsive="sm"
                      head-variant="dark"
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="table.itemsSystem"
                      :fields="table.fieldsSystem"
                      :current-page="table.currentPageSystem"
                      :per-page="table.perPage"
                      :busy="table.isBusySystem"
                      v-if="table.itemsSystem.length || table.isBusySystem">

                  <template v-slot:cell(id)="data">
                    <b>#{{data.item.id}}</b>
                  </template>

                  <template v-slot:cell(name)="data">
                    {{data.item.name}}
                  </template>

                  <template v-slot:cell(related_count)="data">
                    {{getRelatedCount(data.item)}}
                  </template>

                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
                      <b-dropdown-item @click="edit(data.item)">
                        <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                      </b-dropdown-item>
                      <b-dropdown-item @click="remove(data.item)">
                        <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
              </b-table>
              <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="table.tablePaginateSystem">
            <b-col>
              <nav>
                <b-pagination class="pull-right mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginateSystem.total"
                              :per-page="table.tablePaginateSystem.per_page"
                              v-model="table.currentPageSystem"
                              @input="filterSystem()" />
              </nav>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize>
          {{this.modal.form.title}}
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import FindObject from '@/components/inc/find/findObject'
  import Storage from '@/handler/storageLocal'

  export default {
    components: {
      FindObject,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.INSTANCIAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudInstancesCategories',
          elements: {}
        },
        activeTab: 0,
        table : {
          itemsServer: [],
          itemsSystem: [],
          fieldsServer: [
            {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
            {key: 'name', label: 'Nombre', class: 'align-middle'},
            {key: 'related_count', label: 'Servidores', class: 'align-middle text-center'},
            {key: 'f_action', label:'', class: 'text-center'},
          ],
          fieldsSystem: [
            {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
            {key: 'name', label: 'Nombre', class: 'align-middle'},
            {key: 'related_count', label: 'Sistemas', class: 'align-middle text-center'},
            {key: 'f_action', label:'', class: 'text-center'},
          ],
          currentPageServer: 1,
          currentPageSystem: 1,
          perPage: 0,
          isBusyServer: false,
          isBusySystem: false,
          tablePaginateServer: null,
          tablePaginateSystem: null,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            type: 'server',
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.restoreTabStorage()
      this.filterServer()
      this.filterSystem()
    },
    methods: {
      // tab memory
      onTabChange(tabIndex) {
        Storage.setValue('instances_categories_active_tab', tabIndex)
      },
      restoreTabStorage() {
        var savedTab = Storage.getValue('instances_categories_active_tab')
        if(savedTab !== null && savedTab !== undefined) {
          this.activeTab = parseInt(savedTab)
        }
      },
      getRelatedCount(item) {
        if(!item) {
          return 0
        }

        if(item.type === 'server' && item.servers_count !== undefined && item.servers_count !== null) {
          return item.servers_count
        }

        if(item.type === 'system' && item.systems_count !== undefined && item.systems_count !== null) {
          return item.systems_count
        }

        if(item.servers_count !== undefined && item.servers_count !== null) {
          return item.servers_count
        }

        if(item.systems_count !== undefined && item.systems_count !== null) {
          return item.systems_count
        }

        if(Array.isArray(item.servers)) {
          return item.servers.length
        }

        if(Array.isArray(item.systems)) {
          return item.systems.length
        }

        return 0
      },

      // crud
      filterServer() {
        this.table.isBusyServer = true

        var result = serviceAPI.filtrarCategories({ type: 'server' }, this.table.currentPageServer)

        result.then((response) => {
          var data = response.data
          this.table.tablePaginateServer = data
          this.table.itemsServer = data.data

          if(this.$refs.tableServer) {
            this.$refs.tableServer.$forceUpdate()
          }

          this.table.isBusyServer = false
        })
        .catch(error => {
          this.table.isBusyServer = false
        });
      },
      filterSystem() {
        this.table.isBusySystem = true

        var result = serviceAPI.filtrarCategories({ type: 'system' }, this.table.currentPageSystem)

        result.then((response) => {
          var data = response.data
          this.table.tablePaginateSystem = data
          this.table.itemsSystem = data.data

          if(this.$refs.tableSystem) {
            this.$refs.tableSystem.$forceUpdate()
          }

          this.table.isBusySystem = false
        })
        .catch(error => {
          this.table.isBusySystem = false
        });
      },
      add(type) {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.type = type

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = type === 'server' ? "Nueva Categoría para Servidores" : "Nueva Categoría para Sistemas"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.type = item.type

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Categoría"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.type = item.type

        this.$bvModal.msgBoxConfirm('¿Desea borrar la categoría (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Categoría',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCategories(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterServer()
              this.filterSystem()
              this.$awn.success("Categoría eliminada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        if (this.crud.form.id) {
          var result = serviceAPI.editarCategories(this.crud.form);
        } else {
          var result = serviceAPI.agregarCategories(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.filterServer()
          this.filterSystem()
          this.$awn.success("Cambios guardado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
<style>

</style>
